import { render } from "./MatrixKpiRow.vue?vue&type=template&id=99fd2428&scoped=true"
import script from "./MatrixKpiRow.vue?vue&type=script&lang=js"
export * from "./MatrixKpiRow.vue?vue&type=script&lang=js"

import "./MatrixKpiRow.vue?vue&type=style&index=0&id=99fd2428&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99fd2428"]])

export default __exports__